<script>
import { fieldValidationsMixin } from '@/mixins/fieldValidationsMixin'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
export default {
  mixins: [validationMixin, fieldValidationsMixin],
  validations: {
    email: { required, email }
  },
  data() {
    return {
      content: '',
      email: ''
    }
  },
  methods: {
    reset() {
      this.email = ''
    }
  }
}
</script>
<template>
  <div>
    <v-row dense>
      <v-col cols="12">
        <v-text-field
          id="em_email"
          v-model="email"
          :label="$t('global.email.hyphen')"
          :error-messages="[
            ...fieldNeccessary('email', $v),
            ...emailInvalid('email', $v)
          ]"
          outlined
          dense
          required
          @input="$v.email.$touch()"
        />
      </v-col>
    </v-row>
  </div>
</template>
